import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

interface NotifyItem {
  id: number;
  wx_account_id: number;
  group_name?: string;
  speaker?: string;
  content?: string;
  channel?: string;
  status?: string;
  created_at?: string;
}

export default function NotificationsPage() {
  const { data, isLoading, error } = useQuery<{ items: NotifyItem[]; total: number }>({
    queryKey: ['notifications'],
    queryFn: () => api.get('/api/notifications'),
  });

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-slate-800">通知记录</h2>
      {error && <div className="rounded bg-red-50 px-3 py-2 text-sm text-red-700">{(error as Error).message}</div>}
      <div className="card overflow-hidden p-0">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
            <tr>
              <th className="px-4 py-2">时间</th>
              <th className="px-4 py-2">群</th>
              <th className="px-4 py-2">发言人</th>
              <th className="px-4 py-2">内容</th>
              <th className="px-4 py-2">通道</th>
              <th className="px-4 py-2">状态</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {isLoading && (
              <tr><td className="px-4 py-6 text-center text-slate-400" colSpan={6}>加载中...</td></tr>
            )}
            {!isLoading && (data?.items ?? []).length === 0 && (
              <tr><td className="px-4 py-6 text-center text-slate-400" colSpan={6}>暂无记录</td></tr>
            )}
            {(data?.items ?? []).map((n) => (
              <tr key={n.id}>
                <td className="px-4 py-2 text-slate-500 whitespace-nowrap">{n.created_at ?? '-'}</td>
                <td className="px-4 py-2 text-slate-700">{n.group_name ?? '-'}</td>
                <td className="px-4 py-2 text-slate-700">{n.speaker ?? '-'}</td>
                <td className="px-4 py-2 text-slate-800 max-w-md truncate">{n.content ?? '-'}</td>
                <td className="px-4 py-2 text-slate-500">{n.channel ?? '-'}</td>
                <td className="px-4 py-2 text-slate-500">{n.status ?? '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
